import React from 'react';
import { bannerVariants } from './Banner.cva';

interface BannerProps {
  imageUrl: string;
  imageAlt?: string;
  children: React.ReactNode;
  overlayOpacity?: number;
  isGrayscale?: boolean;
  isFullHeight?: boolean;
}

const Banner: React.FC<BannerProps> = ({
  imageUrl,
  imageAlt = '',
  children,
  overlayOpacity = 0.4,
  isGrayscale = false,
  isFullHeight = false,
}) => {
  return (
    <div className={bannerVariants({ isFullHeight })}>
      <img
        src={imageUrl}
        alt={imageAlt}
        className={`absolute top-0 left-0 w-full h-full object-cover object-right select-none pointer-events-none ${
          isGrayscale ? 'grayscale' : ''
        }`}
        draggable={false}
      />
      <div
        className="absolute inset-0 z-10"
        style={{ background: `rgba(0,0,0,${overlayOpacity})` }}
      />
      <div className="z-20 flex flex-col items-center justify-center w-full h-full">{children}</div>
    </div>
  );
};

export default Banner;
